import { render, staticRenderFns } from "./ListHorariosLab.vue?vue&type=template&id=c35ef044&scoped=true&"
import script from "./ListHorariosLab.vue?vue&type=script&lang=js&"
export * from "./ListHorariosLab.vue?vue&type=script&lang=js&"
import style0 from "./ListHorariosLab.vue?vue&type=style&index=0&id=c35ef044&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35ef044",
  null
  
)

export default component.exports